// extracted by mini-css-extract-plugin
module.exports = {"root":"ResultCounter_root_3F0Ge","value":"ResultCounter_value_2jECo"};